import axios from 'axios';

const api = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}/api/devices`,
  timeout: parseInt(process.env.REACT_APP_API_TIMEOUT) || 10000
});

export const getDevicesByLayout = async (layoutId) => {
  const response = await api.get(`/layout/${layoutId}`);
  return response.data;
};

export const addDeviceToLayout = async (deviceData) => {
  const response = await api.post(`/`, deviceData);
  return response.data;
};

export const updateDeviceInLayout = async (deviceId, deviceData) => {
  const response = await api.put(`/${deviceId}`, deviceData);
  return response.data;
};

export const removeDeviceFromLayout = async (deviceId) => {
  const response = await api.delete(`/${deviceId}`);
  return response.data;
};

export const getAllDevices = async () => {
  const response = await api.get('/');
  return response.data;
};

export const getDeviceById = async (id) => {
  const response = await api.get(`/${id}`);
  return response.data;
};
